import styles from './styles.module.scss';
import React from 'react';

const Text = ({ children, className = '', onClick }) => {
  return (
    <div className={`${styles.container}${` `}${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

export default Text;
